export default {
      id: "ic_notifications-usage",
      viewBox: "0 0 20 20",
      url: "../dist/images/" + "sprite.svg#ic_notifications-usage",
      toString: function () {
        return this.url;
      }
    }